module.exports = __webpack_public_path__ + "media/images/icon-knowledge-a049322f45a1f97fff8304a274cdba2d.svg";